import { Box, Typography } from "@mui/material";
import AnimatedButton from "../../Components/AnimatedButton/AnimatedButton.jsx";  



function About() {
  return (
    <Box
            sx={{
              width: "100%",
              minHeight: "100vh",
              display: "flex",
              bgcolor: "#f5f5f5",
            }}
          >
            {/* Left Content */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                px: { xs: 4, md: 8, lg: 12 },
                py: 8,
              }}
            >
    
              {/* Main Heading */}
              <Typography
                sx={{
                  fontSize: { xs: "32px", md: "42px", lg: "48px" },
                  lineHeight: 1.3,
                  color: "#222",
                  mb: 4,
                  fontWeight: 400,
                  maxWidth: "600px",
                  letterSpacing: "1px",
                }}
              >
                TRUE VALUE FOR MONEY - IN EVERY SALON, EVERY STEP
                <br />
                <span style={{ fontWeight: 600 }}>TVFM</span>
              </Typography>
    
              {/* Description */}
              <Typography
                sx={{
                  fontSize: "15px",
                  lineHeight: 1.8,
                  color: "#666",
                  mb: 5,
                  maxWidth: "550px",
                }}
              >
                DEPOT offers a complete and unparalleled range of professional products
                of high quality and a collection of exclusive barbershops to satisfy all
                the needs of the most demanding male beauty routine. Solutions dedicated
                to hair, shaving and beard care are integrated with body products,
                personal fragrances, unique treatments and rituals, to give life to
                always top-quality experiences, at home as at the barber's.
              </Typography>
    
              {/* Button */}
                <Box  
                  sx={{
                    cursor: "pointer",
                  }}
                >
                    <AnimatedButton text="our concept  →" />
                  </Box>
            </Box>
    
            {/* Right Images - Ultra Attractive Design */}
            <Box
              sx={{
                flex: 1,
                display: { xs: "none", md: "flex" },
                position: "relative",
                overflow: "hidden",
              }}
            >
              {/* Main Hero Image with Parallax Effect */}
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  position: "relative",
                  overflow: "hidden",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "linear-gradient(135deg, rgba(0,0,0,0.5) 0%, transparent 60%)",
                    zIndex: 1,
                  },
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=1200"
                  alt="Professional Barber"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform 0.5s ease",
                  }}
                />
                
                {/* Floating Text Overlay */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 60,
                    left: 40,
                    zIndex: 2,
                    color: "white",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      letterSpacing: "3px",
                      mb: 1,
                      opacity: 0.9,
                    }}
                  >
                    PROFESSIONAL
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "36px",
                      fontWeight: 700,
                      lineHeight: 1,
                    }}
                  >
                    GROOMING
                  </Typography>
                </Box>
              </Box>
    
              
    
            </Box>
          </Box>
  );
}

export default About;


